export default {
  IcbLevel1: 'Ngành cấp 1',
  IcbLevel2: 'Ngành cấp 2',
  IcbLevel3: 'Ngành cấp 3',
  IcbLevel4: 'Ngành cấp 4',
  listTitleTable: {
    SECTOR: 'Ngành', // hh:mm
    CLOSE_INDEX: 'Chỉ số',
    INDEX_CHANGE: 'Thay đổi',
    TOTAL_VOLUME: 'Tổng KL',
    TOTAL_VALUE: 'Tổng GT',
    TOTAL_MATCH_VOLUME: 'KL Khớp',
    TOTAL_MATCH_VALUE: 'GT Khớp',
    VOLUME_RATIO: 'Tỷ lệ vượt KL',
    VALUE_RATIO: 'Tỷ lệ vượt GT',
    PERCENT_INDEX_CHANGE: '% Thay đổi',
    PERCENT_1D_CHANGE: '% 1 ngày',
    PERCENT_1W_CHANGE: '% 5 ngày',
    PERCENT_2W_CHANGE: '% 10 ngày',
    PERCENT_1M_CHANGE: '% 20 ngày',
    AVG_VALUE_1W: 'GT Khớp/ GTKTB 5N',
    AVG_VALUE_2W: 'GT Khớp/ GTKTB 10N',
    AVG_VALUE_1M: 'GT Khớp/ GTKTB 20N',
    AVG_VOLUME_1W: 'KL Khớp/ KLKTB 5N',
    AVG_VOLUME_2W: 'KL Khớp/ KLKTB 10N',
    AVG_VOLUME_1M: 'KL Khớp/ KLKTB 20N',
  },
  timeRange: {
    ONE_DAY: '1 NGÀY',
    FIVE_DAY: '5 NGÀY',
    TEN_DAY: '10 NGÀY',
    TWENTY_DAY: '20 NGÀY',
  },
  legend: {
    totalVolume: 'Khối lượng khớp',
    percentPriceChange: '%1D Change',
  },
  xAxis: {
    totalVolume1D: 'Khối lượng khớp',
    totalVolume5D: 'KLTB Khớp 5 Ngày (Nghìn cổ phiếu)',
    totalVolume10D: 'KLTB Khớp 10 Ngày (Nghìn cổ phiếu)',
    totalVolume20D: 'KLTB Khớp 20 Ngày (Nghìn cổ phiếu)',
    percentPriceChange1D: '% Thay đổi 1 Ngày',
    percentPriceChange5D: '% Thay đổi 5 Ngày',
    percentPriceChange10D: '% Thay đổi 10 Ngày',
    percentPriceChange20D: '% Thay đổi 20 Ngày',
  },
  tooltip: {
    volume: 'Khối lượng khớp',
    volume5D: 'KLTB Khớp 5N',
    volume10D: 'KLTB Khớp 10N',
    volume20D: 'KLTB Khớp 20N',
    percentPriceChange1D: '% Thay đổi',
    percentPriceChange5D: '% Thay đổi 5N',
    percentPriceChange10D: '% Thay đổi 10N',
    percentPriceChange20D: '% Thay đổi 20N',
    value: 'Giá trị khớp',
    value5D: 'GTTB Khớp 5N',
    value10D: 'GTTB Khớp 10N',
    value20D: 'GTTB Khớp 20N',
    unitValue: 'Triệu Đồng',
    unitVolume: 'Nghìn CP',
  },
  chartName: 'BIẾN ĐỘNG NGÀNH',
  footer:
    'Khối lượng: x 1,000. Giá Trị: x 1,000,000. Mỗi ngành bao gồm tất cả cổ phiếu từ HOSE, HNX và UPCOM. (Dữ liệu Hose realtime được tính toán vào dữ liệu ngành sau 9h15 AM.)',
};
